export function deploymentOnline(now, epoch) {
  if (epoch === null) return false;
  return (now - new Date(epoch)) / 1000 / 60 < 20;
}
